import { DeviceIndex, ServerId, Device } from 'types';

const idRegex = /^(\d+)\|(\d+)$/;

export class ReportDevice {
    readonly serverId: ServerId;
    readonly deviceIndex: DeviceIndex;

    static fromString(s: string): ReportDevice {
        const match = idRegex.exec(s);
        if (match) {
            return new ReportDevice(
                parseInt(match[1], 10),
                parseInt(match[2], 10)
            );
        }
        throw new Error(`Invalid server and device id's: ${s}`);
    }

    static fromCamera(camera: Device): ReportDevice {
        return new ReportDevice(camera.serverId, camera.deviceIndex);
    }

    constructor(serverId: ServerId, deviceIndex: DeviceIndex) {
        this.serverId = serverId;
        this.deviceIndex = deviceIndex;
    }

    toString(): string {
        return `${this.serverId}|${this.deviceIndex}`;
    }
}



// WEBPACK FOOTER //
// ./src/logic/reports/ReportDevice.ts